export const initFormData = {
  filePath: '',
}

export const rules = {
  filePath: [{ required: true, message: "请上传excel文件", trigger: "blur" }],
};
